/**
 * Set inline styles.
 * @param {object} props - The block object.
 * @return {object} The inline text color CSS.
 */
function TypographyStyles( props ) {
	return {
	}
}

export default TypographyStyles
